<template>
  <div>
    <EquipmentTable @toSchedule="$emit('toSchedule')" />
  </div>
</template>

<script>
import EquipmentTable from '../components/equipment/table/equipamentTable.vue'
export default {
  components: {
    EquipmentTable,
  },
}
</script>

<style lang="scss" scoped></style>
